import { ActiveTabUserListActionType } from '../../types/activeTabUserList'

export const setActiveTabUserList = (value: string) => {
    return {type: ActiveTabUserListActionType.SET_ACTIVE_TAB_USER_LIST, payload: value}
}